module.exports = __webpack_public_path__ + "img/intro_phone4.e8e6a883.png";